import { Alert, Button, Stack, TextField } from '@mui/material';
import type { InvitationRateLimitState } from '../../../mainApi';

type WorkspaceMembersInviteProps = {
  isSaving: boolean;
  inviteEmails: string;
  inviteMessage: string;
  onInviteEmailsChange: (value: string) => void;
  onInviteMessageChange: (value: string) => void;
  onInvite: () => void;
  rateLimit: InvitationRateLimitState | null;
};

export const WorkspaceMembersInvite = ({
  isSaving,
  inviteEmails,
  inviteMessage,
  onInviteEmailsChange,
  onInviteMessageChange,
  onInvite,
  rateLimit,
}: WorkspaceMembersInviteProps) => (
  <Stack spacing={1.5} sx={{ pt: 1 }}>
    {rateLimit?.emailSendingBlocked ? (
      <Alert severity="error">Email sending has been disabled for this account.</Alert>
    ) : rateLimit?.remaining === 0 ? (
      <Alert severity="warning">
        You have reached the limit of {rateLimit.limit} email invitations per hour.
        {rateLimit.resetAt
          ? ` You can send more after ${new Date(rateLimit.resetAt).toLocaleTimeString()}.`
          : ''}
      </Alert>
    ) : null}
    <TextField
      label="Invite emails"
      value={inviteEmails}
      onChange={(event) => onInviteEmailsChange(event.target.value)}
      helperText="Comma or semicolon separated emails"
      disabled={isSaving || rateLimit?.remaining === 0}
      fullWidth
    />
    <TextField
      label="Message (optional)"
      value={inviteMessage}
      onChange={(event) => onInviteMessageChange(event.target.value)}
      minRows={3}
      multiline
      disabled={isSaving || rateLimit?.remaining === 0}
      fullWidth
    />
    <Stack direction="row" justifyContent="flex-end">
      <Button
        variant="contained"
        onClick={onInvite}
        disabled={isSaving || !inviteEmails.trim() || rateLimit?.remaining === 0}
      >
        Send invites
      </Button>
    </Stack>
  </Stack>
);
